import { render, staticRenderFns } from "./ProductTierDialog.vue?vue&type=template&id=1a07aa9c&"
import script from "./ProductTierDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductTierDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports